module.exports = __webpack_public_path__ + "nu.svg?482618606f493a8f71e79003956049a0";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/nu.svg
// module id = 1549
// module chunks = 0